// src/service/enquiryService.js
import { MAIN_API } from "../../config/api";

const enquiryService = {
  // Create new enquiry
  createEnquiry: async (enquiryData, files = []) => {
    try {
      const endpoint = `${MAIN_API}/add/user/enquiry`;

      console.log('Creating enquiry at:', endpoint);
      console.log('Enquiry data:', enquiryData);
      console.log('Files:', files);

      const formData = new FormData();

      // ✅ Send enquiryData as JSON string with proper Blob
      const enquiryDataBlob = new Blob([JSON.stringify(enquiryData)], {
        type: 'application/json'
      });
      formData.append('enquiryData', enquiryDataBlob);

      // ✅ Add files with proper content type
      if (files && files.length > 0) {
        files.forEach((file) => {
          // Create a new File object with proper type if needed
          const fileToSend = new File([file], file.name, {
            type: file.type || 'application/octet-stream'
          });
          formData.append('files', fileToSend);
        });
      }

      const response = await fetch(endpoint, {
        method: 'POST',
        body: formData,
        // ✅ Don't set Content-Type header - let browser handle it
      });

      const data = await response.json();
      console.log('Enquiry response:', data);
      return data;
    } catch (error) {
      console.error('Error creating enquiry:', error);
      throw { success: false, message: error.message || 'Failed to create enquiry. Please try again.' };
    }
  },

  // ✅ Get all enquiries for a user
  getEnquiriesByUser: async (userId) => {
    try {
      const endpoint = `${MAIN_API}/user/enquiry/getAll/${userId}`;

      console.log('Fetching enquiries from:', endpoint);

      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      console.log('Enquiries response:', data);
      return data;
    } catch (error) {
      console.error('Error fetching enquiries:', error);
      throw { success: false, message: error.message || 'Failed to fetch enquiries. Please try again.' };
    }
  },

  // ✅ Get single enquiry by ID (for detail page)
  // src/service/enquiryService.js

  // ✅ Get single enquiry by ID (for detail page)
  getEnquiryById: async (enquiryId) => {
    try {
      const endpoint = `${MAIN_API}/user/enquiry/get/${enquiryId}`;

      console.log('Fetching enquiry from:', endpoint);

      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      console.log('Enquiry detail response:', data);

      // ✅ Return the data directly if it has an id
      if (data && data.id) {
        return data;
      }

      return data;
    } catch (error) {
      console.error('Error fetching enquiry:', error);
      throw { success: false, message: error.message || 'Failed to fetch enquiry details. Please try again.' };
    }
  },
};

export default enquiryService;